import styled from 'styled-components';

import { aspectRatio, colors, fontFamily } from '../../ui/variables';

export const XRayChartStyle = styled.div`
  background-color: ${colors.mostlyWhite};
  border-radius: 12px;
  overflow: hidden;
  padding: 28px 0 0;
  position: relative;

  &.chart-only {
    background-color: transparent;
    border-radius: initial;
    overflow: initial;
    padding: 0;
    width: 100%;

    .x-ray-content-wrapper {
      padding: 0;
      width: 100%;

      .x-ray-content {
        ${aspectRatio.ratio1To1};
        position: relative;

        .circles-wrapper {
          left: 0;
          position: absolute;
          top: 0;

          .chart-circle-color {
            top: 0;
          }

          .chart-circle-value {
            top: 25%;
          }
        }
      }
    }
  }

  .x-ray-scale {
    margin-bottom: 48px;
    margin-left: 13px;
    margin-right: 13px;
    padding: 0 20px;

    .x-ray-scale-colors {
      background: linear-gradient(
        -90deg,
        ${colors.brightRed} 0%,
        ${colors.lightOrange} 20%,
        ${colors.softYellow} 40%,
        ${colors.limeGreen} 60%,
        ${colors.brightBlue} 80%,
        ${colors.softBlue} 100%
      );
      height: 36px;
      position: relative;
      width: 100%;

      .x-ray-scale-pointer {
        ${fontFamily.sourceSansPro.bold};
        color: ${colors.veryDarkGrayishBlue};
        font-size: 12px;
        line-height: 15px;
        white-space: nowrap;
        position: absolute;
        text-align: center;
        top: -6px;
        transform: translateX(-50%);

        &:before {
          background-color: ${colors.veryDarkGrayishBlue};
          content: '';
          display: block;
          height: 48px;
          margin: 0 auto 4px;
          width: 3px;
        }
      }
    }
  }

  .x-ray-content-wrapper {
    padding: 0 22% 32px;

    .x-ray-content {
      ${aspectRatio.ratio1To1};
      margin: 0 auto;
      position: relative;
      width: 100%;

      .circles-wrapper {
        ${aspectRatio.ratio1To1};
        border-radius: 50%;
        position: absolute;
        transform-origin: center center;

        .chart-circle-color {
          ${aspectRatio.ratio1To1};
          background: white;
          border-radius: 50%;
          left: 0;
          position: absolute;
          top: -100%;
          width: 100%;
        }

        .chart-circle-value {
          background: ${colors.verySoftBlue};
          border-radius: 50%;
          left: 25%;
          padding-top: 50%;
          position: absolute;
          top: -75%;
          width: 50%;

          .circle-value {
            ${fontFamily.sourceSansPro.bold};
            color: ${colors.veryDarkGrayishBlue};
            font-size: 28px;
            left: 50%;
            line-height: 28px;
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }

    .x-ray-classification {
      ${fontFamily.sourceSansPro.bold};
      color: ${colors.veryDarkGrayishBlue};
      font-size: 14px;
      line-height: 18px;
      margin-top: 24px;
      text-align: center;
      text-transform: uppercase;
    }
  }
`;
